export default "/_next/static/images/93ffe9d63b83bdec4a15177e19ceb4c3.jpg";